'use client';

import { motion } from 'framer-motion';
import { Award, Building2, Globe2, Users } from 'lucide-react';
import { OroExpressWordmark } from '@/components/shared/OroExpressWordmark';
import { SocialLinks } from '@/components/shared/SocialLinks';
import { COMPANY } from '@/lib/constants';

const corporateStats = [
  { icon: Award, value: '15+', label: 'Años de trayectoria sectorial' },
  { icon: Users, value: '12.000+', label: 'Clientes formados e informados' },
  { icon: Globe2, value: 'LBMA', label: 'Refinerías Good Delivery' },
  { icon: Building2, value: '100%', label: 'Capital y origen español' },
];

export function AboutOroExpress() {
  return (
    <section className="container-page py-20 sm:py-24">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        className="grid gap-10 rounded-3xl border border-white/10 bg-navy-900/40 p-8 backdrop-blur-md sm:p-12 lg:grid-cols-12"
      >
        <div className="space-y-6 lg:col-span-7">
          <div className="flex items-center gap-3">
            <p className="text-xs uppercase tracking-[0.2em] text-gold-300">
              Sobre nosotros
            </p>
            <span className="h-px flex-1 max-w-[60px] bg-gold-500/30" />
          </div>
          <OroExpressWordmark variant="full" />
          <h2 className="heading-display text-3xl text-cream sm:text-4xl">
            Una academia con{' '}
            <span className="text-gold-gradient">respaldo profesional</span>
          </h2>
          <div className="space-y-4 text-cream/75">
            <p className="leading-relaxed">
              Esta academia es una iniciativa de {COMPANY.name}, distribuidor
              especializado en oro físico de inversión con sede en España.
              Trabajamos con refinerías LBMA Good Delivery, factura legal con
              IVA exento sobre oro de inversión y cumplimos íntegramente la
              normativa antiblanqueo.
            </p>
            <p className="leading-relaxed">
              Creemos que un mercado sano necesita inversores informados. Por
              eso ponemos a disposición este curso completo, sin coste ni
              compromiso comercial. Si después decides comprar oro, podrás
              elegir libremente; nuestro objetivo es que tomes la decisión con
              criterio.
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-4 pt-2">
            <a
              href={COMPANY.website}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-gold-300 transition-colors hover:text-gold-glow"
            >
              Conocer Oro Express →
            </a>
            <span className="hidden h-4 w-px bg-white/10 sm:inline-block" />
            <div className="flex items-center gap-3">
              <span className="text-xs uppercase tracking-[0.2em] text-cream/55">
                Síguenos
              </span>
              <SocialLinks variant="compact" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 lg:col-span-5">
          {corporateStats.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.label}
                className="rounded-2xl border border-white/10 bg-navy-950/40 p-5 text-center backdrop-blur"
              >
                <Icon className="mx-auto h-6 w-6 text-gold-400" />
                <div className="mt-3 font-display text-2xl font-bold text-cream">
                  {s.value}
                </div>
                <div className="mt-1 text-xs leading-snug text-cream/60">
                  {s.label}
                </div>
              </div>
            );
          })}
        </div>
      </motion.div>
    </section>
  );
}
